module.exports = function() {
  return new Worker("/" + "b381be0525886ec95f09.worker.js");
};